import React, { useState, useEffect, useRef } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Space,
  Select,
  DatePicker,
  Table,
  Input,
  Col,
  Form,
  Row,
  Popconfirm,
  Tooltip,
  Button,
  Dropdown,
  Checkbox,
  Menu,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import RefreshIcon from "../../image/refreshIcon.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { getRequest, postRequest, patchRequest } from "../../axios";
import moment from "moment";
import DealDone from "../../image/DealDone.svg";
import Proposal from "../../image/Proposal.svg";
import OpenIcon from "../../image/OpenIcon.svg";
import Delete from "../../image/trophy.png";
import Busy from "../../image/Busy.svg";
import Callcenter from "../../image/Callcenter.svg";
import OrderApprove from "../../image/OrderApprove.svg";
import rejectedIcon from "../../image/rejectedIcon.svg";
import TotalCount from "../../image/TotalCount.svg";
import OrderIssuedApprove from "../../image/OrderIssuedApprove.svg";
import OrderYetAccepted from "../../image/OrderYetAccepted.svg";
import { confirmAlert } from "react-confirm-alert";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import ComparedIcon from "../../image/ComparedIcon.svg";
import { authUserData } from "../../utils/Helper";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import {
  DownloadOutlined,
  FileDoneOutlined,
  FilterOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { font } from "../../common/font";
import { ReactComponent as ColumnList } from "../../image/ColumnList.svg";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const GeneralPurchaseOrderSummary = () => {
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const { rfqId } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [rfqStatus, setRfqStatus] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const formRef = useRef();
  const [selectedCard, setSelectedCard] = useState(null);
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeFilter, setCategoryTreeFilter] = useState("");
  const { id } = useParams();
  const [categoryId, setCategoryId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const [statusCounts, setStatusCounts] = useState({
    total_purchase_order: 0,
    pending_for_approval: 0,
    send_for_approval: 0,
    approve_and_issued_order: 0,
    approve_and_prepare_draft_order: 0,
    rejected: 0,
    rejected_with_reason: 0,
    order_accepted_by_vendor: 0,
    order_rejected_by_vendor: 0,
  });
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
  });
  useEffect(() => {
    const getRFQHistory = async () => {
      setLoading(true);

        const queryParams = new URLSearchParams({
          company_id: CompanyId,
          page: state.page,
          page_size: state.pagesize,
          ...(state.search && { search: state.search }),
          ...(state.po_created_date__gte && {
            po_created_date__gte: state.po_created_date__gte,
          }),
          ...(state.po_created_date__lte && {
            po_created_date__lte: state.po_created_date__lte,
          }),
          ...(state.po_status && { po_status: state.po_status }),
        });
      try {
        const apiResponse = await getRequest(
          `combined-po-order/?${queryParams.toString()}`
        );
        if (apiResponse.data.results?.data) {
          setRFQHistory(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else if (apiResponse.data.data) {
          setRFQHistory(apiResponse.data.data);
          settotalCount(apiResponse.data.count || apiResponse.data.data.length);
        } else {
          ErrorNotificationMsg(t("error_in_rfq_history"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    const getStatusCount = async () => {
      // setLoading(true);

      try {
        let apiResponse = await getRequest(
          `combined-po-order/${CompanyId}/po-status-count/`
        );
        if (apiResponse.data.success) {
          const message = apiResponse.data.data;
          setStatusCounts({
            total_purchase_order: message.total_purchase_order,
            pending_for_approval: message.pending_for_approval,
            send_for_approval: message.send_for_approval,
            approve_and_issued_order: message.approve_and_issued_order,
            approve_and_prepare_draft_order:
              message.approve_and_prepare_draft_order,
            rejected: message.rejected,
            rejected_with_reason: message.rejected_with_reason,
            order_accepted_by_vendor: message.order_accepted_by_vendor,
            order_rejected_by_vendor: message.order_rejected_by_vendor,
          });
        } else {
          ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
        }
        // setLoading(false);
      } catch (error) {
        //setLoading(false);
      }
    };

    getRFQHistory();
    getStatusCount();
    getCategoryTree();
  }, [reload, state, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setEndDate(formattedDate);
  };
  //
  const handleCategoryChange = (value) => {
    setCategoryTreeFilter(value);
  };

  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
      }
    );
  };
  const handleReset = () => {
    setSelectedCard(null);
    setClickedFilterButton(false);
    setRfqStatus("");
    setEndDate("");
    setStartDate("");
    setCategoryTreeFilter("");

    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
    formRef.current.setFieldsValue({
      po_created_date__gte: null,
      pr_created_date__lte: null,
      pr_created_date__gte: null,
      rfq_detail: null,
      category_id: null,
      po_created_date__lte: null,
    });
  };
  const handleClearFields = () => {
    setEndDate("");
    setStartDate("");
  };
  const handleClickCard = (value) => {
    setSelectedCard(value);
    setEndDate("");
    setStartDate("");
    setRfqStatus("");
    setCategoryTreeFilter("");
    setCategoryTreeFilter("");
    formRef.current.setFieldsValue({
      pr_created_date__lte: null,
      pr_created_date__gte: null,
    });
    setState({
      ...state,
      po_status: value,
      page: 1,
      pagesize: 10,
    });
  };

  const handlePdfDownload = async () => {
    // const endpoint = `po-order/${CompanyId}/po-order-excel-download/`;
    // const fileType = "csv";
    //
    // try {
    //   await getRequest(endpoint)
    //     .then((response) => {
    //       const blob = new Blob([response.data], {
    //         type: "text/csv",
    //       });
    //       const link = document.createElement("a");
    //       link.href = window.URL.createObjectURL(blob);
    //       link.download = `float-rfq_${+new Date()}.${fileType}`;
    //       link.click();
    //     })
    //     .catch((error) => {
    //       //ErrorNotificationMsg(t(`err_${fileType}_download`));
    //     });
    // } catch (error) {
    //   //setBtnloading(false);
    //   //ErrorNotificationMsg(error);
    // }

    /* PDF Download */
    const pdf = new jsPDF("p", "pt", "a4", true);
    pdf.addFileToVFS("WorkSans-normal.ttf", font);
    pdf.addFont("WorkSans-normal.ttf", "WorkSans", "normal");
    pdf.setFont("WorkSans");
    const pdfColumns = [
      "RFQ Number",
      "PO Number",
      "Vendor",
      "Site Location",
      "Amount Without GST",
      "Amount With GST",
      "Status",
    ];
    let rows = [];

    for (let i = 0; i < rfqHistory.length; i++) {
      let temp = [
        rfqHistory[i].rfq_number,
        rfqHistory[i].po_number,
        rfqHistory[i].vendor_name,
        rfqHistory[i].rfq_site_names,
        "₹ " +
          rfqHistory[i].amount_without_gst.toLocaleString("en-IN", {
            maximumFractionDigits: 0,
          }),
        "₹ " +
          rfqHistory[i].amount_with_gst.toLocaleString("en-IN", {
            maximumFractionDigits: 0,
          }),
        rfqHistory[i].po_status,
      ];
      rows.push(temp);
    }
    pdf.text(210, 40, "Purchase Order Summary");
    pdf.autoTable(pdfColumns, rows, {
      startY: 65,
      theme: "grid",
      styles: {
        font: "WorkSans",
        halign: "center",
        overflow: "linebreak",
        cellPadding: 3.5,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        textColor: [0, 0, 0],
      },
      headStyles: {
        textColor: [255, 255, 255],
        fontStyle: "normal",
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        fillColor: [9, 78, 143],
      },
      alternateRowStyles: {
        fillColor: [212, 212, 212],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      rowStyles: {
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      tableLineColor: [0, 0, 0],
      columnStyles: {
        4: { halign: "right" },
        5: { halign: "right" },
      },
    });
    pdf.save(`general_purchase_order_summary_${CompanyId}_${+new Date()}`);
  };

  const handleApplyFilter = () => {
    setSelectedCard(null);
    setClickedFilterButton(true);
    setState({
      ...state,
      page: 1,
      po_created_date__gte: startDate,
      po_created_date__lte: endDate,
      po_status: selectedCard || "",
    });
  };
  const savePurchaseOrderStatus = async (id) => {
    try {
      let apiResponse = await patchRequest(
        `general-po-order/${id}/po-approval-status-change/`,
        {
          po_status: "Approve and Issued Order",
        }
      );
      if (apiResponse.data.success) {
        SuccessNotificationMsg(apiResponse.data.message);
        setReload(!reload);
      } else {
        ErrorNotificationMsg(t("error_in_rfq_history_archive"));
      }
    } catch (error) {
      ErrorNotificationMsg(error.response.data.message);
    }
  };
  const handleApprovePurchaseOrder = async (id) => {
    confirmAlert({
      title: "Confirm",
      message: `Are you sure you want to Approve and Issue this order ?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => savePurchaseOrderStatus(id),
        },
        {
          label: "No",
          //onClick: () => ErrorNotificationMsg("Cancelled"),
        },
      ],
    });
  };

  const handleDownload = (id, vendorId, poType) => {
    const normalizedPoType = String(poType || "").toLowerCase().trim();
    const pdfPath =
      normalizedPoType === "general"
        ? `/pdfdownload-general-purchase-order-details/pdf/${id}/${vendorId}`
        : `/pdfdownload-purchase-order-details/pdf/${id}/${vendorId}`;

    window.open(pdfPath, "_blank");
  };

  const handleRefresh = async () => {
    setSelectedCard(null);
    setEndDate("");
    setStartDate("");
    formRef.current.setFieldsValue({
      pr_created_date__lte: null,
      pr_created_date__gte: null,
    });
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
    });
  };

  const columns = [
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      // width: 100,
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      key: "po_number",
      // width: 100,
    },
    {
      title: "PO Type",
      dataIndex: "po_type",
      key: "po_type",
      // width: 120,
    },
    {
      title: "Vendor",
      dataIndex: "vendor_name",
      key: "vendor_name",
      // width: 150,
    },
    {
      title: "PO Date",
      dataIndex: "po_approval_date",
      key: "po_approval_date",
      // width: 100,
      render: (value, row) => {
        return (
          <div>
            {value !== null
              ? moment(value).format("DD-MM-YYYY")
              : "Pending"}
          </div>
        );
      },
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      align: "right",
      className: "column-right",
      // width: 130,
      render: (amount_without_gst) => {
        return (
          <p>
            {`\u20B9 ${
              amount_without_gst?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }) || 0
            }`}
          </p>
        );
      },
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      align: "right",
      className: "column-right",
      // width: 130,
      render: (amount_with_gst) => {
        return (
          <p>
            {`\u20B9 ${
              amount_with_gst?.toLocaleString("en-IN", {
                maximumFractionDigits: 0,
              }) || 0
            }`}
          </p>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "po_status",
      key: "po_status",
      // width: 240,
    },
    // {
    //   title: "Delivery Status",
    //   dataIndex: "delivery_status",
    //   key: "delivery_status",
    //   // width: 240,
    // },



    {
      title: "Action",
      fixed: "right",
      key: "Action",
      // width: 150,
      render: (record) => {
        return (
          <Space>
            <Tooltip
              title="View & Download Purchase Order"
              color="#094E8F"
              placement="left"
            >
              <DownloadOutlined
                onClick={() =>
                  handleDownload(record.id, record.vendor, record.po_type)
                }
              />
            </Tooltip>

            {record.po_status === "Approve and Prepare Draft Order" && (
              <Tooltip
                title="Approve Purchase Order"
                color="#094E8F"
                placement="left"
              >
                <FileDoneOutlined
                  onClick={() => handleApprovePurchaseOrder(record.float_rfq)}
                />
              </Tooltip>
            )}
          </Space>
        );
      },
    },
  ];

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    if (value) {
      setState({
        ...state,
        page: 1,
        search: value,
      });
    } else {
      const { search, ...newState } = state; // Remove 'search' key from state
      setState(newState);
    }
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const [checkedList, setCheckedList] = useState([
    "rfq_number",
    "po_number",
    "po_type",
    "vendor_name",
    "po_approval_date",
    "amount_without_gst",
    "amount_with_gst",
    "po_status",
    "Action",
  ]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter((column) =>
    checkedList.includes(column.key)
  );

  // Column filter dropdown menu
  const columnMenu = (
    <Menu
      className="packagelistdropdown"
      style={{ width: "450px", padding: "10px", borderRadius: "8px" }}
    >
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Row style={{ width: "100%" }}>
            <Col span={12}>
              <Checkbox value="rfq_number">RFQ Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_number">PO Number</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_type">PO Type</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="vendor_name">Vendor</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_approval_date">PO Date</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="amount_without_gst">Amount Without GST</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="amount_with_gst">Amount With GST</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="po_status">Status</Checkbox>
            </Col>
            
            <Col span={12}>
              <Checkbox value="Action" disabled>
                Action
              </Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Purchase Order Summary</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/general-procurement-list">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Purchase Order Summary</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("Search by PO number")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
          </Space>
        </div>
      </div>
      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
        <SubscriptionNotification />
          <section className="Block-Sec-Demo1 mb-5">
            <Row gutter={[15]} className="rfqCard">
              {[
                {
                  status: "",
                  title: "Total No. Of Order",
                  count: statusCounts.total_purchase_order,
                  icon: TotalCount,
                  clickHandler: () => handleClickCard(""),
                },
                {
                  status: "Approve and Issued Order",
                  title: "Order Issued",
                  count: statusCounts.approve_and_issued_order,
                  icon: OrderIssuedApprove,
                  clickHandler: () =>
                    handleClickCard("Approve and Issued Order"),
                },
                {
                  status: "Pending for Approval",
                  title: "Order Yet to be Accepted",
                  count: statusCounts.pending_for_approval,
                  icon: OrderYetAccepted,
                  clickHandler: () =>
                    handleClickCard("Pending for Approval"),
                },
                {
                  status: "Order Accepted By Vendor",
                  title: "Order Accepted By Vendor",
                  count: statusCounts.order_accepted_by_vendor,
                  icon: OrderApprove,
                  clickHandler: () =>
                    handleClickCard("Order Accepted By Vendor"),
                },
                {
                  status: "Order Rejected By Vendor",
                  title: "Order Rejected By Vendor",
                  count: statusCounts.order_rejected_by_vendor,
                  icon: rejectedIcon,
                  clickHandler: () => handleClickCard("Order Rejected By Vendor"),
                },
              ].map((item, index) => (
                <Col key={index}>
                  <div
                    className={`card mb-5 ${
                      selectedCard === item.status ? "active" : ""
                    }`}
                    onClick={item.clickHandler}
                    style={{
                      width: "fit-content",
                    }}
                  >
                    <div className={`card-block block-${index + 1}`}>
                      <div className="card-box">
                        <div className="card-icon">
                          <img src={item.icon} alt={item.title} width={35} />
                        </div>
                        <div className="card-description">
                          <h3 className="color-blue">{item.title}</h3>
                          <p>{item.count}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </section>
          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="po_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select start date"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="po_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select end date"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  {/* {endDate || startDate || categoryTreeFilter || rfqStatus ? ( */}
                  <>
                    <Button
                      type="primary"
                      htmlType="Apply"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                      onClick={startDate || endDate ? handleApplyFilter : null}
                    />
                    <Button
                      type="primary"
                      htmlType="Reset"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        width: "40px",
                        height: "40px",
                        borderRadius: "4px",
                      }}
                      onClick={
                        clickedFilterButton ? handleReset : handleClearFields
                      }
                    />
                  </>
                  {/* ) : (
                    ""
                  )} */}
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                {/* <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="PDF"
                  label="PDF"
                  onClick={handlePdfDownload}
                  icon={<img src={ExelDownload} alt="PDF Icon" />}
                /> */}
                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Refresh"
                  label="Refresh"
                  onClick={handleRefresh}
                  icon={<img src={RefreshIcon} alt="Refresh Icon" />}
                />
                <div>
                  <Space
                    style={{
                      backgroundColor: "#094e8f",
                      padding: "4px",
                      borderRadius: "4px",
                    }}
                  >
                    <Dropdown
                      overlay={columnMenu}
                      trigger={["click"]}
                      placement="bottomRight"
                      visible={dropdownVisible}
                      onVisibleChange={setDropdownVisible}
                    >
                      <Tooltip
                        title="Modify Columns"
                        placement="topLeft"
                        color="#094E8F"
                      >
                        <Button
                          type="primary"
                          icon={<ColumnList />}
                          onClick={(e) => e.preventDefault()}
                          style={{
                            backgroundColor: "#094e8f",
                            color: "#ffffff",
                            border: "none",
                            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          }}
                        />
                      </Tooltip>
                    </Dropdown>
                  </Space>
                </div>
              </Space>
            </div>
          </div>
          <div className="tablewrp">
          <Table
            columns={filteredColumns}
            // rowSelection={rowSelection}
            dataSource={rfqHistory}
            rowKey={(record) => record.id}
            scroll={{
              x: 'auto',
              // y: 400,
            }}
            loading={loading}
            pagination={{
              current: state.page,
              pageSize: state.pagesize,
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
          </div>
        </div>
      </section>
    </>
  );
};
export default GeneralPurchaseOrderSummary;
